export enum LDFlags {
  accountNumberBackup = 'account-number-backup',
  conferenceFunnelUtilities = 'conference-funnel-utilities',
  createNewUtilityAccount = 'flex-funnels-create-new-utility-account',
  embeddedSigningIpa = 'embedded-signing-ipa',
  showLocalizeWidget = 'ff-show-localize-widget',
  useEnvelopeForLmiForm = 'cs-show-lmi-self-attestation-form',

  lmiProofDocsState = 'cs-lmi-proof-docs-state',
  lmiSelfAttestationState = 'cs-lmi-self-attestation-state',
  maDocusign = 'cs-ma-docusign',
  newMexicoDocusign = 'cs-new-mexico-docusign',
  placeCreditCardHold = 'cs-place-card-hold',
  welcomeBackEnabled = 'flex-funnels-welcome-back-enabled',
  showSpanishLanguage = 'ff-should-set-spanish-language',
  showMicroLearningScreens = 'ff-should-show-micro-learning',
  showSecondaryAccountIdentifier = 'ff-should-show-secondary-account-identifier',
  showFallbackButton = 'ff-show-fallback-button',
  billImageUpload = 'ff-bill-upload-backup',
  showBudgetBillingCheckBox = 'ff-budget-billing-checkbox-dominion',
  showSmsOptInCheckbox = 'ff-show-sms-opt-in',
  showDualBillExplainer = 'ff-show-dual-explainer-screen',
  skipUtilityConnect = 'ff-can-skip-utility-connect',
  showUtiltityAccountNumberScreen = 'ff-show-account-no-fallback-screen',
  shouldResyncUtilityCredential = 'should-resync-utility-credential',
  allowUserToSkipLmiProof = 'ff_allow_skip_lmi_proof',
  allowPaymentSkipIfUcbAvailable = 'ff-allow-payment-skip-if-ucb-available',
  applyCenergyDiscount = 'ff-cenergy-promocode-discount',
  showLmiNoticeInLegalPage = 'ff-show-lmi-notice-in-legal-page',
  useTwilioVerifyInInputPage = 'ff-use-twilio-verify-in-input-page',
  waitlistEnabled = 'ff-waitlist-funnel-enabled',
  calendlyEnabled = 'ff-calendly-enabled',
  fetchUtilityEnrollmentOptions = 'ff-utility-enrolment-options',
  showLmiSelfAttestationPostPayment = 'ff-lmi-self-attestation-post-payment',
  shouldBlockSignups = 'ff-block-signups',
  shouldBlockSignupsForSmb = 'ff-block-signups-in-smb',
  showPersonalizedContractPreview = 'cs-enable-personalized-contracts',
  showRewardsGuidelines = 'ff-show-rewards-guidelines',
  shouldUseNYLmiNewFlow = 'ff-ny-lmi-zone-new-flow',
  shouldUseVALmiFlow = 'ff-va-lmi-new-flow',
  fetchUtilityLmiProofDocOptions = 'ff-utility-lmi-proof-doc-options',
  ffUtilityLmiProofDocsLabelOptions = 'ff-utility-lmi-proof-docs-label-options',
  showOnlySolarLandscapeContracts = 'ff-show-only-solar-landscape-contracts',
  nmUtilitiesAllowedProjectIds = 'ff-nm-utilities-allowed-project-ids',
  // This flag is used to determine if the user should be
  // allowed to update their language preference in the database
  ffAllowLanguageUpdateApi = 'ff-allow-language-update-api',
  ffUseGeoCoderForMd = 'ff-use-geocoder-logic-for-md',
  energywellShouldHoldPayment = 'ff-is-payment-hold-screen-enabled',
  ffUseZeroBounceEmailVerification = 'ff-use-zerobounce-email-verification',
  enableAttestationFields = 'ff-enable-extra-fields-for-attestation',
  enableLmiOptionsRadioButtons = 'ff-enable-lmi-option-radio-buttons',
  /**
   * This flag is contains the list of promo codes
   * that are blacklisted for affiliate file drop
   */
  epBlacklistedAffiliatePromoCodes = 'ep-blacklisted-affiliate-promo-codes',
  ffShowMeterNumber = 'ff-show-meter-number',
  enableFallbackOnNoServiceAddress = 'ff-fallback-on-no-service-address',
  ffSkipPaymentScreen = 'ff-skip-payment-screen-for-testing',
  ffDefaultSignupProjectId = 'ff-default-signup-project-id',
  ffProofDocTypeRequirePdf = 'ff-proof-doc-type-require-pdf',
  enableManualProofCapture = 'enable-manual-capture-of-proofs',
  ffEnableNJAffirmativeConsent = 'ff-enable-nj-affirmative-consent',
  enableUnitilMA = 'ff-enable-unitil-ma',
  ffFeatureEnableBilluploadOnUcFail = 'ff-feature-enable-billupload-on-uc-fail',
}
